module.exports = __webpack_public_path__ + "img/icon-18.01df2618.png";